import { I18nComponente } from "@/types/gerais"

export const TCriarNovaSenhai18n: I18nComponente = {
  "pt-BR": {
    novaSenha: "nova senha",
    confirmarSenha: "confirmar senha",
    crieUmaSenhaForte: "crie uma senha forte",
    deveConterNumerosLetraCaracteresEspeciais: "deve conter números, letras e caracteres especiais",
    deveConterPeloMenos8Caracteres: "deve conter pelo menos 8 caracteres",
    deveConterPeloMenos1LetraMinuscula: "deve conter pelo menos 1 letra minúscula",
    voltar: "voltar",
    continuar: "continuar",
    senhaDeveConterPeloMenosUmCaractereMaiusculo: "A senha deve conter pelo menos um caractere maiúsculo",
    senhaDeveConterNoMinimo8Caracteres: "A senha deve conter no mínimo 8 caracteres",
    senhaDeveConterPeloMenosUmNumero: "A senha deve conter pelo menos um número",
    senhaDeveConterPeloMenosUmCaractereEspecial: "A senha deve conter pelo menos um caractere especial (#?!@$%^&*-)",
    senhaDeveSerIgual: "A senha deve ser igual",
    senhaRedefinidaComSucesso: "Senha redefinida com sucesso",
    voceJaPodeAcessarSistemaUsandoSuaNovaSenha: "Você já pode acessar o sistema usando sua nova senha",
    linkDeRedefinicaoDeSenhaInvalido: "O link de redefinição de senha é inválido ou expirou.",
    erroAoAlterarSenha: "Erro ao alterar senha",
  },
  "es-CO": {
    novaSenha: "nueva contraseña",
    confirmarSenha: "confirmar contraseña",
    crieUmaSenhaForte: "crea una contraseña fuerte",
    deveConterNumerosLetraCaracteresEspeciais: "debe contener números, letras y caracteres especiales",
    deveConterPeloMenos8Caracteres: "debe contener al menos 8 caracteres",
    deveConterPeloMenos1LetraMinuscula: "debe contener al menos 1 letra minúscula",
    voltar: "volver",
    continuar: "continuar",
    senhaDeveConterPeloMenosUmCaractereMaiusculo: "La contraseña debe contener al menos un carácter mayúsculo",
    senhaDeveConterNoMinimo8Caracteres: "La contraseña debe contener al menos 8 caracteres",
    senhaDeveConterPeloMenosUmNumero: "La contraseña debe contener al menos un número",
    senhaDeveConterPeloMenosUmCaractereEspecial: "La contraseña debe contener al menos un carácter especial (#?!@$%^&*-)",
    senhaDeveSerIgual: "La contraseña debe ser igual",
    senhaRedefinidaComSucesso: "Contraseña redefinida con éxito",
    voceJaPodeAcessarSistemaUsandoSuaNovaSenha: "Ya puedes acceder al sistema usando tu nueva contraseña",
    linkDeRedefinicaoDeSenhaInvalido: "El enlace de restablecimiento de contraseña no es válido o ha caducado.",
    erroAoAlterarSenha: "Error al cambiar la contraseña",
  }
}
